import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseConsentHubApiUrl } from '../..';
import { getImpersonationHeader } from 'util/mac/helpers';

export const postToHamsClient = async (remainingPath: string, state: State) => {
  try {
    const config = selectHamsClientConfig(state);
    const impersonationHeader = getImpersonationHeader(state);

    return (
      await hamsClient.post(
        `${baseConsentHubApiUrl}${remainingPath}`,
        {},
        {
          ...config,
          headers: {
            ...config.headers,
            ...impersonationHeader,
          },
        },
      )
    ).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
